import { ListItem, Grid, Typography } from "@material-ui/core";
import { useState } from "react";
import { url } from "../../../constants";
import millify from "millify";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";

const ListCard = (props) => {
  const [noLogo, setNoLogo] = useState(false);
  const { Company } = props;
  const marketingCap = props?.etf
    ? Company?.Assets_Under_Management?.toString().split(".")
    : Company?.MarketCapital?.toString().split(".");
  const marketingCapInt = marketingCap ? marketingCap[0]?.length : 0;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);

  return (
    <ListItem style={{ padding: 0 }}>
      <Grid
        style={{
          width: "757px",
          display: "flex",
          alignItems: "center",
          paddingLeft: isDesktopOrLaptop ? "243px" : null,
          //    paddingRight: isDesktopOrLaptop ? "10px" : null,
          paddingTop: "10px",
          paddingBottom: "10px",
        }}
      >
        <Grid item xs={2}>
          {props?.etf ? (
            <Typography
              style={{
                fontFamily: "Overpass",
                fontSize: "14px",
                textAlign: "center",
                color: "#808080",
                maxWidth: "75px",
              }}
            >
              {Company?.ISIN}
            </Typography>
          ) : (
            <div
              style={{
                height: "30px",
                marginTop: "5px",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: noLogo ? "0 0 11px 0 #16063b26" : "",
                //  backgroundColor: "#fff",
                //  padding: "59px 8px 50 9px"
                cursor: "pointer",
              }}
              onClick={() => {
                props.setCompanyDetail(Company?.ISIN);
              }}
            >
              {noLogo ? null : (
                <div
                  style={{
                    height: "90%",
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={`${url}/static/ISINlogo/${Company?.logos}`}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",

                      // width: "75px",
                      // height: "auto",
                      padding: "0 8px 0 8px",
                    }}
                    onError={(e) => {
                      setNoLogo(!noLogo);
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </Grid>
        <Grid item xs={4}>
          <Typography
            style={{
              color: "#16063b",
              fontSize: "16px",
              fontWeight: 900,
              fontFamily: "Overpass",
              height: "27px",
              cursor: "pointer",
              paddingLeft: "20px",
            }}
            onClick={() => {
              props.setCompanyDetail(Company?.ISIN);
            }}
          >
            {Company?.Name?.substr(0, 22)}
            {Company?.Name?.length > 22 ? "..." : null}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            style={{
              color: "#0040ff",
              fontSize: "14px",
              fontWeight: 800,
              fontFamily: "Overpass",
              height: "15px",
              lineHeight: 1.07,
            }}
          >
            {props?.etf
              ? Company?.Issuer?.substr(0, 18)
              : Company?.Sector?.substr(0, 18)}
            {props?.etf
              ? Company?.Issuer?.length > 18
              : Company?.Sector?.length > 18
              ? "..."
              : null}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            style={{
              color: "#2a0f67",
              fontSize: "14px",
              fontWeight: 800,
              fontFamily: "Overpass",
            }}
          >
            {Company?.MarketCapital === -99999.99 ? (
              "Not Available"
            ) : props?.etf ? (
              marketingCapInt < 7 ? (
                millify(
                  Company?.Assets_Under_Management
                    ? Company?.Assets_Under_Management
                    : 0,
                  {
                    units: ["M USD", "B USD"],
                    space: true,
                    precision: 2,
                  }
                )
              ) : (
                <NumberFormat
                  value={
                    Company?.Assets_Under_Management
                      ? Company?.Assets_Under_Management / 1000
                      : 0 / 1000
                  }
                  thousandSeparator={"'"}
                  displayType="text"
                  suffix={" B USD"}
                  decimalScale={2}
                />
              )
            ) : marketingCapInt < 7 ? (
              millify(Company?.MarketCapital ? Company?.MarketCapital : 0, {
                units: ["M USD", "B USD"],
                space: true,
                precision: 2,
              })
            ) : (
              <NumberFormat
                value={
                  Company?.MarketCapital
                    ? Company?.MarketCapital / 1000
                    : 0 / 1000
                }
                thousandSeparator={"'"}
                displayType="text"
                suffix={" B USD"}
                decimalScale={2}
              />
            )}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <img
            alt="logo"
            style={{ width: "50%" }}
            src={`${url}/static/CountryFlag/${Company?.Country}.jpg`}
            onError={(e) => {
              e.target.src =
                "https://i.pinimg.com/originals/f9/11/d3/f911d38579709636499618b6b3d9b6f6.jpg";
            }}
          ></img>
        </Grid>
      </Grid>
    </ListItem>
  );
};

export default ListCard;
